export const addToFavoritesCategoryText = "s_0P9c";
export const addToFavoritesCategoryTextTeams = "OmREce";
export default {addToFavoritesCategoryText,addToFavoritesCategoryTextTeams};